import React from 'react';
import { tutoService } from 'core/services';
import TUTOQuestionForm from '../Form';
import { useHistory } from 'react-router';

type Props = {};

const TUTOQuestionCreate: React.FC<Props> = () => {
    const history = useHistory();

    const onSubmit = (question) => {
        tutoService.createFaq(question).then(() => history.push('/tuto/questions'));
    };

    return <TUTOQuestionForm onCreate={onSubmit}></TUTOQuestionForm>;
};

export default TUTOQuestionCreate;
